import { cx } from "@emotion/css";
import $ from "jquery";
import { useEffect, useRef, useState } from "react";
import { DunsMgrClaimCtaComponent } from "@/components/DunsMgrClaimCta/DunsMgrClaimCta";
import { body, consolidatedHeaderObject, dnbComLog, getViewportIsMobile, isNotUndefined, isUndefined, LogSeverity, track_event, windowOnLoadOrImmediate } from "@/shared/FunctionCore";
import { filterOutUndefineds } from "@/shared/Internal";
// import { dummyData } from "@/anchorTabDummyResponse";
import React from "react";
import { SectionDataWithSelectorAndExistsAndOffsetTop, SectionDataWithSelectorAndExists, SectionDataWithSelector, AnchorItemsResourceChild } from "@/IAnchor";
import { useTranslation } from "react-i18next";

let timeoutId: number | undefined = void 0;
const Anchors = ({props}): JSX.Element => {
  const { t } = useTranslation();
  const tabs: AnchorItemsResourceChild[] = t("companyProfile.anchor.tabs", { returnObjects: true });

  const {
    // anchorItemsResourceChildCollection,
    companyProfileHeaderTitle,
    componentclass,
    dnbHooversFreeTrialBtnLink,
    dunsMgrClaimCtaData
  } = props;

  const anchorsComponentFixedRef = useRef<HTMLDivElement>(null);
  const anchorsComponentNotFixedRef = useRef<HTMLDivElement>(null);
  const companyAnchorTabsLiTabWithClosestAnchorFixedRef = useRef<HTMLLIElement>(null);
  const companyAnchorTabsLiTabWithClosestAnchorNotFixedRef = useRef<HTMLLIElement>(null);
  const companyAnchorsTabsUlFixedRef = useRef<HTMLUListElement>(null);
  const companyAnchorsTabsUlNotFixedRef = useRef<HTMLUListElement>(null);

  const [headerHeight, setHeaderHeight] = useState(0);
  const [isMobileWidth, setIsMobileWidth] = useState(false);
  const [maximumScrollLeft, setMaximumScrollLeft] = useState(0);
  const [offsetTopAdjusted, setOffsetTopAdjusted] = useState<number | undefined>();
  const [scrollLeft, setScrollLeft] = useState(0);
  const [sectionDataWithSelectorAndExistsAndOffsetTopArrayOrUndefined, setSectionDataWithSelectorAndExistsAndOffsetTopArrayOrUndefined] = useState<SectionDataWithSelectorAndExistsAndOffsetTop[]>([]);
  const [sectionDataWithSelectorAndExistsArray, setSectionDataWithSelectorAndExistsArray] = useState<SectionDataWithSelectorAndExists[] | undefined>();
  const [sectionDataWithSelectorArrayOrUndefinedFiltered, setSectionDataWithSelectorArrayOrUndefinedFiltered] = useState<SectionDataWithSelector[] | undefined>();
  const [windowPageYOffsetArray, setWindowPageYOffsetArray] = useState([0, 0]);
  const [isButtonMounted, setIsButtonMounted] = useState(false);

  const checkHeaderClasses = () => {
    const headerIsBeingShown = consolidatedHeaderObject.showHeader && consolidatedHeaderObject.headerPosition;

    setWindowPageYOffsetArray((ar) => {
      const firstElement = ar[0]!;

      const negativeOrPositive = headerIsBeingShown ? 1 : -1;

      const delta = 10 * negativeOrPositive;

      return [firstElement, firstElement + delta];
    });
  };

  const getCompanyAnchorsTabUlArray = () => [companyAnchorsTabsUlFixedRef, companyAnchorsTabsUlNotFixedRef].map((mu) => mu.current);

  useEffect(() => {
    const determineMaximumScrollLeft = () => {
      getCompanyAnchorsTabUlArray().some((ht) => {
        if (ht === null) {
          return false;
        } else {
          setMaximumScrollLeft(document.getElementsByClassName(ht.className)[0]!.scrollWidth - document.getElementsByClassName(ht.className)[0]!.clientWidth);
          setIsButtonMounted(true);
          return true;
        }
      });
    };

    const determineOffsetTopMinusHeight = () => {
      const anchorsComponentFixedReferenceCurrent = anchorsComponentFixedRef.current;
      const anchorsComponentNotFixedReferenceCurrent = anchorsComponentNotFixedRef.current;

      if (anchorsComponentNotFixedReferenceCurrent !== null && anchorsComponentFixedReferenceCurrent !== null) {
        const $anchorsComponentFixedRefCurrent = $(anchorsComponentFixedReferenceCurrent);
        const $anchorsComponentNotFixedReferenceCurrent = $(anchorsComponentNotFixedReferenceCurrent);

        const anchorsComponentFixedReferenceCurrentHeight = $anchorsComponentFixedRefCurrent.height();
        const anchorsComponentNotFixedRefCurrentHeight = $anchorsComponentNotFixedReferenceCurrent.height();

        const offset = $anchorsComponentNotFixedReferenceCurrent.offset();

        if (isNotUndefined(anchorsComponentFixedReferenceCurrentHeight) && isNotUndefined(anchorsComponentNotFixedRefCurrentHeight) && isNotUndefined(offset)) {
          setOffsetTopAdjusted(-anchorsComponentFixedReferenceCurrentHeight + anchorsComponentNotFixedRefCurrentHeight + offset.top);
        }
      }
    };

    let $consolidatedHeaderWrapper: JQuery | undefined;

    const determineHeaderHeight = () => {
      if (isNotUndefined($consolidatedHeaderWrapper)) {
        const height = $consolidatedHeaderWrapper.height();

        if (isNotUndefined(height)) {
          setHeaderHeight(height);
        }
      }
    };

    consolidatedHeaderObject.registerConsolidatedHeaderWrapperCallback(($element) => {
      $consolidatedHeaderWrapper = $element;

      // Hack
      const resizeObserver = new ResizeObserver(determineHeaderHeight);

      resizeObserver.observe($element[0]!);
    });

    const readyLoadResize = () => {
      setIsMobileWidth(getViewportIsMobile());
      determineMaximumScrollLeft();
      determineOffsetTopMinusHeight();
    };

    $(() => {
      readyLoadResize();

      determineHeaderHeight();
    });

    windowOnLoadOrImmediate(
      $(window),
      () => {
        readyLoadResize();

        determineHeaderHeight();
      })
      .on("resize", () => {
        readyLoadResize();

        // Start of hack
        if (isNotUndefined(timeoutId)) {
          window.clearTimeout(timeoutId);
        }

        // Faster check
        timeoutId = window.setTimeout(() => {
          checkHeaderClasses();

          // Slower check
          window.setTimeout(checkHeaderClasses, 100);
        }, 10);
        // End of hack
      })
      .on("scroll", () =>
        setWindowPageYOffsetArray((ar) => {
          const firstElement = ar[0]!;
          const windowPageYOffset = window.pageYOffset;

          return firstElement === windowPageYOffset ? ar : [windowPageYOffset, firstElement];
        }));
  }, [isButtonMounted]);

  useEffect(() => {
    const sectionDataWithSelectorOrUndefinedArray: (SectionDataWithSelector | undefined)[] = tabs!.map((an) => {
      const anchorLinkName = an.anchorLinkName;

      let selector: string | undefined = void 0;

      if (isNotUndefined(anchorLinkName)) {
        const hrefSplit = anchorLinkName.split("#");

        if (hrefSplit.length < 2) {
          dnbComLog(LogSeverity.ERROR, "hrefSplit in AnchorsComponent has a length less than 2");
        } else {
          const target = hrefSplit[1];

          selector = `a.anchor[data-name=${target}]`;
        }
      } else {
        dnbComLog(LogSeverity.ERROR, "href in AnchorsComponent is undefined");
      }

      if (isUndefined(selector)) {
        return void 0;
      }

      return {
        "anchorTabItemsChildren": an,
        "selector": selector,
      };
    });

    const sectionDataWithSelectorArray = filterOutUndefineds(sectionDataWithSelectorOrUndefinedArray);

    const setAnchorsSectionData = () => {
      // TODO Temporary fix
      if ($(".business-directory-redesign-container .company-added-fields").length > 0) {
        $('.business-directory-redesign-container > a.anchor[name="company_new_enhanced_fields_anchor"]').attr("data-name", "added-by-anchor");
      }

      const sectionDataWithSelectorAndExistsArrayTwo: SectionDataWithSelectorAndExists[] = sectionDataWithSelectorArray.map((se) => {
        const exists = $(se.selector).length > 0;

        return {
          "exists": exists,
          "sectionDataWithSelector": se,
        };
      });

      setSectionDataWithSelectorAndExistsArray(sectionDataWithSelectorAndExistsArrayTwo);

      const sectionDataWithSelectorArrayOrNullFiltered: SectionDataWithSelector[] = [];

      for (const se of sectionDataWithSelectorAndExistsArrayTwo) {
        if (se.exists) {
          sectionDataWithSelectorArrayOrNullFiltered.push(se.sectionDataWithSelector);
        }
      }

      setSectionDataWithSelectorAndExistsArray(sectionDataWithSelectorAndExistsArrayTwo);
      setSectionDataWithSelectorArrayOrUndefinedFiltered(sectionDataWithSelectorArrayOrNullFiltered);
    };

    // Wait to see which sections are available
    $(setAnchorsSectionData);

    // TODO Hack
    window["___SET_ANCHORS_SECTION_DATA___"] = setAnchorsSectionData;
  }, [tabs]);

  useEffect(() => {
    const determineSectionDataWithSelectorAndExistsAndOffsetTop = () => {
      if (isNotUndefined(sectionDataWithSelectorArrayOrUndefinedFiltered)) {
        const sectionDataWithSelectorAndExistsAndOffsetTop: SectionDataWithSelectorAndExistsAndOffsetTop[] = sectionDataWithSelectorArrayOrUndefinedFiltered.map((sectionDataWithSelector) => {
          const offset = $(sectionDataWithSelector.selector).offset();

          let offsetTop: number | undefined;

          if (isNotUndefined(offset)) {
            offsetTop = offset.top;
          } else {

            offsetTop = void 0;
          }

          return { "offsetTop": offsetTop, "sectionDataWithSelector": sectionDataWithSelector };
        });

        setSectionDataWithSelectorAndExistsAndOffsetTopArrayOrUndefined(sectionDataWithSelectorAndExistsAndOffsetTop);
      }
    };

    determineSectionDataWithSelectorAndExistsAndOffsetTop();

    $(determineSectionDataWithSelectorAndExistsAndOffsetTop);

    windowOnLoadOrImmediate($(window), determineSectionDataWithSelectorAndExistsAndOffsetTop).on("resize", determineSectionDataWithSelectorAndExistsAndOffsetTop);
  }, [sectionDataWithSelectorArrayOrUndefinedFiltered]);

  const firstElement = windowPageYOffsetArray[0]!;

  const downwardScroll = firstElement > windowPageYOffsetArray[1]!;

  const headerHidden = downwardScroll || isMobileWidth;

  const headerOffset = headerHidden ? 0 : -headerHeight;

  const offsetToCheck = isNotUndefined(offsetTopAdjusted) ? offsetTopAdjusted + headerOffset : void 0;

  const pastOffsetToCheck = isNotUndefined(offsetToCheck) && firstElement > offsetToCheck;

  const button = (isLeft: boolean) => {
    // Show button if scrollbar is almost at the left/right edge
    const threshold = 2;

    const doNotDisplayButton = (isLeft && scrollLeft < threshold) || (!isLeft && maximumScrollLeft - scrollLeft < threshold);

    return (
      <button
        aria-label={isLeft ? "companyAnchorTabsButtonLeft" : "companyAnchorTabsButtonRight"}
        className={`companyAnchorTabsButton ${isLeft ? "companyAnchorTabsButtonLeft" : "companyAnchorTabsButtonRight"} ${doNotDisplayButton ? "doNotDisplayButton" : void 0}`}
        onClick={() => {
          const increment = 150;

          const newScrollLeft = isLeft ? window.Math.max(0, -increment + scrollLeft) : window.Math.min(increment + scrollLeft, maximumScrollLeft);

          for (const ht of getCompanyAnchorsTabUlArray()) {
            if (ht !== null) {
              const $ht = $(ht);

              if ($ht.filter(":animated").length === 0) {
                $ht.animate(
                  {
                    "scrollLeft": isLeft ? `${newScrollLeft}px` : `+=${newScrollLeft}px`,
                  },
                  {
                    "duration": 300,
                    "easing": "linear",
                  }
                );
              }
            }
          }
        }}
        type="button"
      >
        <div className="companyAnchorTabsIcon" />
      </button>
    );
  };

  let anchorLinkNameOfTabWithClosestAnchor: string | undefined = void 0;
  let lowestOffsetTopDeltaFromScrollPosition: number | undefined = void 0;

  if (isNotUndefined(sectionDataWithSelectorAndExistsAndOffsetTopArrayOrUndefined)) {
    for (const se of sectionDataWithSelectorAndExistsAndOffsetTopArrayOrUndefined) {
      const offsetTop = se.offsetTop;

      if (isNotUndefined(offsetTop)) {
        const offsetTopDeltaFromScrollPosition = window.Math.abs(offsetTop - firstElement);

        if (isUndefined(lowestOffsetTopDeltaFromScrollPosition) || offsetTopDeltaFromScrollPosition < lowestOffsetTopDeltaFromScrollPosition) {
          anchorLinkNameOfTabWithClosestAnchor = se.sectionDataWithSelector.anchorTabItemsChildren.anchorLinkName;
          lowestOffsetTopDeltaFromScrollPosition = offsetTopDeltaFromScrollPosition;
        }
      } else {
        dnbComLog(LogSeverity.ERROR, "offsetTop is null");
      }
    }
  }

  useEffect(() => {
    let newScrollLeftOrNull: number | undefined = void 0;

    [
      { "li": companyAnchorTabsLiTabWithClosestAnchorFixedRef, "ul": companyAnchorsTabsUlFixedRef },
      { "li": companyAnchorTabsLiTabWithClosestAnchorNotFixedRef, "ul": companyAnchorsTabsUlNotFixedRef },
    ].forEach((va) => {
      if (isNotUndefined(anchorLinkNameOfTabWithClosestAnchor)) {
        const vaLiCurrent = va.li.current;
        const vaUlCurrent = va.ul.current;

        if (vaLiCurrent !== null && vaUlCurrent !== null) {
          const $vaLiCurrent = $(vaLiCurrent);
          const $vaUlCurrent = $(vaUlCurrent);

          const performAnimatedScroll = (newScrollLeft: number) => {
            $vaUlCurrent.stop().animate(
              {
                "scrollLeft": newScrollLeft,
              },
              {
                "duration": 300,
                "easing": "linear",
              }
            );
          };

          if (isNotUndefined(newScrollLeftOrNull)) {
            performAnimatedScroll(newScrollLeftOrNull);
          } else {
            const vaLiCurrentOffset = $vaLiCurrent.offset();
            const vaLiCurrentWidth = $vaLiCurrent.width();
            const vaUlCurrentWidth = $vaUlCurrent.width();

            if (isNotUndefined(vaLiCurrentOffset) && isNotUndefined(vaLiCurrentWidth) && isNotUndefined(vaUlCurrentWidth)) {
              const left = vaLiCurrentOffset.left;

              const vaLiCurrentWidthDividedByTwo = vaLiCurrentWidth / 2;
              const vaUlCurrentWidthDividedByTwo = vaUlCurrentWidth / 2;

              const vaUlCurrentScrollLeft = vaUlCurrent.scrollLeft;

              const newScrollLeftUnchecked = left + vaLiCurrentWidthDividedByTwo + vaUlCurrentScrollLeft - vaUlCurrentWidthDividedByTwo;

              const newScrollLeft = window.Math.max(0, window.Math.min(newScrollLeftUnchecked, maximumScrollLeft));

              newScrollLeftOrNull = newScrollLeft;

              performAnimatedScroll(newScrollLeft);
            }
          }
        }
      }
    });
  }, [anchorLinkNameOfTabWithClosestAnchor, maximumScrollLeft]);

  const companyAnchorsComponent = (fixed: boolean) => {
    const topPosition = fixed ? (headerHidden ? 0 : headerHeight) : void 0;

    return (
      <div
        className={`companyAnchorsComponent ${fixed ? "fixed" : "notFixed"} ${pastOffsetToCheck ? "pastOffsetToCheck" : void 0} ${componentclass}`}
        ref={fixed ? anchorsComponentFixedRef : anchorsComponentNotFixedRef}
        style={{ "top": topPosition }}>
        {fixed ? (
          <div className="dnbHooversFreeTrialAndDunsMgrClaimCtaWrapper">
            <div className="companyHeading">
              <div className="companyLogo" />

              <div className="companyTitle">
                {companyProfileHeaderTitle}
              </div>
            </div>

            <div>
              <DunsMgrClaimCtaComponent
                dunsMgrClaimCtaData={dunsMgrClaimCtaData!}
                inAnchorsComponent={true} />

              <div className="dnbHooversFreeTrialCtaLinkWrapper">
                <a
                  aria-label="DNB Hoovers Free Trial CTA"
                  className={`dnbHooversFreeTrialCtaLink dnbHooversFreeTrialCtaLink"`}
                  dangerouslySetInnerHTML={{ "__html": t("companyProfile.heading.dnbHooversFreeTrialBtnText") ?? "" }}
                  href={t("companyProfile.heading.dnbHooversFreeTrialBtnLink")}
                  onClick={() => {
                    track_event("dnb_hoovers_free_trial_link_clicked");
                  }}
                />
              </div>
            </div>

          </div>
        ) : (
          <></>
        )}

        <div
          className={`companyAnchorTabs ${fixed ? "fixed" : void 0}`}>
          <div className={`companyAnchorTabsWrapper business-directory-redesign-container`}>
            {/* {maxSLcalculated ?  : <></>} */}
            {isButtonMounted ? button(true) : <></>}

            {
              // TODO Remove this class?
            }

            <div className={cx("companyAnchorTabsInnerWrapper")}>
              <ul
                className="companyAnchorTabsUl"
                onScroll={(sc) => {
                  const currentTarget = sc.currentTarget;

                  const currentTargetScrollLeft = currentTarget.scrollLeft;

                  setScrollLeft(currentTargetScrollLeft);

                  for (const ht of getCompanyAnchorsTabUlArray()) {
                    if (ht !== null && ht !== currentTarget && ht.scrollLeft !== currentTargetScrollLeft) {
                      ht.scrollLeft = currentTargetScrollLeft;
                    }
                  }
                }}
                ref={fixed ? companyAnchorsTabsUlFixedRef : companyAnchorsTabsUlNotFixedRef}
              >
                {isUndefined(sectionDataWithSelectorAndExistsArray) ? (
                  <li className="companyAnchorTabsLi">
                    <span className={`companyAnchorTabsLink visibilityHidden`}>
                      Loading...
                    </span>
                  </li>
                ) : (
                  (() => {
                    const lengthMinusOne = sectionDataWithSelectorAndExistsArray.length - 1;

                    return sectionDataWithSelectorAndExistsArray.map((an, nu) => {
                      const first = nu === 0;
                      const last = nu === lengthMinusOne;

                      const disableTab = !an.exists;

                      const { sectionDataWithSelector } = an;

                      const { anchorTabItemsChildren } = sectionDataWithSelector;

                      const { anchorLinkName } = anchorTabItemsChildren;

                      const isTabWithClosestAnchor = isNotUndefined(anchorLinkNameOfTabWithClosestAnchor) && anchorLinkNameOfTabWithClosestAnchor === anchorLinkName;

                      const { anchorDisplayText } = anchorTabItemsChildren;

                      return (
                        <li
                          className={`companyAnchorTabsLi ${first ? "first" : void 0} ${last ? "last" : void 0}`}
                          key={nu}
                          ref={
                            isTabWithClosestAnchor
                              ?
                              (
                                fixed
                                  ? companyAnchorTabsLiTabWithClosestAnchorFixedRef
                                  : companyAnchorTabsLiTabWithClosestAnchorNotFixedRef
                              )
                              : void 0
                          }
                        >
                          <a
                            className={`companyAnchorTabsLink ${disableTab ? "disableTab" : void 0} ${isTabWithClosestAnchor ? "isTabWithClosestAnchor" : void 0}`}
                            href={anchorLinkName}
                            onClick={(mo) => {
                              mo.preventDefault();

                              if (!disableTab) {
                                const $selector = $(sectionDataWithSelector.selector);

                                const anchorsComponentFixedReferenceCurrent = anchorsComponentFixedRef.current;
                                const selectorOffset = $selector.offset();

                                if (anchorsComponentFixedReferenceCurrent === null) {
                                  dnbComLog(LogSeverity.ERROR, "anchorsComponentFixedRefCurrent is undefined");
                                } else if (isUndefined(headerHeight)) {
                                  dnbComLog(LogSeverity.ERROR, "headerHeight is undefined");
                                } else if (isUndefined(selectorOffset)) {
                                  dnbComLog(LogSeverity.ERROR, "selectorOffset is undefined");
                                } else {
                                  const height = $(anchorsComponentFixedReferenceCurrent).height();

                                  if (isUndefined(height)) {
                                    dnbComLog(LogSeverity.ERROR, "height is undefined");
                                  } else {
                                    const selectorOffsetTop = selectorOffset.top;

                                    // Current position, adjusting for the header and fixed anchors component heights
                                    const adjustedWindowPageYOffset = firstElement + (headerHidden ? 0 : headerHeight) + (pastOffsetToCheck ? height : 0);

                                    // Some scrolls look large to the check after this one because the scroll itself is going to cause a change in visibility of the header and/or fixed anchors
                                    // If the top offset of the anchor being scrolled to is very close to the current scroll position, accounting for the height of the current displayed header and fixed anchors component, don't scroll
                                    // Without this check, scrolls would happen that would open or close the header, but would otherwise not change what non-header content was visible
                                    if (window.Math.abs(selectorOffsetTop - adjustedWindowPageYOffset) > 2) {
                                      const goingToFixed = isNotUndefined(offsetToCheck) && selectorOffsetTop > offsetToCheck;
                                      const willBeDownwardsScroll = selectorOffsetTop > firstElement;

                                      // Fixed anchors component only displayed when browser is scrolled past the non-fixed anchors component
                                      const fixedAnchorsComponentOffset = goingToFixed && isNotUndefined(height) ? -height : 0;
                                      // Downward scroll hides menu
                                      const onClickHeaderOffset = isMobileWidth || willBeDownwardsScroll ? 0 : -headerHeight;

                                      const scrollTop = selectorOffsetTop + fixedAnchorsComponentOffset + onClickHeaderOffset;

                                      const windowPageYOffset = window.pageYOffset;

                                      // Don't scroll if the change in scroll position is going to be very small
                                      if (window.Math.abs(scrollTop - windowPageYOffset) > 2) {
                                        // https://stackoverflow.com/questions/19303405/difference-between-html-body-animate-and-body-animate
                                        $(body).add("html").animate(
                                          {
                                            "scrollTop": scrollTop,
                                          },
                                          {
                                            "duration": 500,
                                          }
                                        );
                                      }
                                    }
                                  }
                                }
                              }
                            }}
                          >
                            {anchorDisplayText}
                          </a>
                        </li>
                      );
                    });
                  })()
                )}
              </ul>
            </div>
            {isButtonMounted ? button(false) : <></>}
            {/* {button(false)} */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {companyAnchorsComponent(false)}

      {companyAnchorsComponent(true)}
    </>
  );
};

export default Anchors
// const anchors = (renderableData: RenderableData<AnchorsParameter>): void => renderIdentifierGeneric(AnchorsComponent, renderableData);
